export default __webpack_public_path__ + "static/media/facebook.8860fc08.svg";